/* empty css                              */
import s from "./td-longtail-vue-components98.js";
const a = {
  name: "TransitionExpand",
  methods: {
    /* eslint-disable no-param-reassign, no-unused-expressions */
    enter(t) {
      t.style.width = getComputedStyle(t).width, t.style.position = "absolute", t.style.visibility = "hidden", t.style.height = "auto";
      const { height: i } = getComputedStyle(t);
      t.style.width = null, t.style.position = null, t.style.visibility = null, t.style.height = 0, getComputedStyle(t).height, requestAnimationFrame(() => {
        t.style.height = i;
      });
    },
    afterEnter(t) {
      t.style.height = "auto";
    },
    leave(t) {
      t.style.height = getComputedStyle(t).height, getComputedStyle(t).height, requestAnimationFrame(() => {
        t.style.height = 0;
      });
    }
    /* eslint-enable no-param-reassign */
  }
};
var r = function() {
  var i = this, e = i._self._c;
  return e("Transition", { attrs: { name: "expand" }, on: { enter: i.enter, "after-enter": i.afterEnter, leave: i.leave } }, [i._t("default")], 2);
}, o = [], n = /* @__PURE__ */ s(
  a,
  r,
  o,
  !1,
  null,
  "ac472b0d"
);
const d = n.exports;
export {
  d as default
};
